import angular from 'angular'

angular.module('nominas.cotizacion')
  .service('NominasCotizacion', NominasCotizacion);

function NominasCotizacion($api, $catalogos, $schema) {
  this.get = get;
  this.crearEmpleado = crearEmpleado;
  this.listEmpleados = listaEmpleados;
  this.listConceptos = listaConceptos;
  this.obtenerIdEmpleado = obtenerIdEmpleado;

  function get(Folio) {
    function Cotizacion(data) {
      angular.extend(this, data);
    }

    Cotizacion.prototype.guardar = guardar;

    function guardar(cerrarCotizacion) {
      let self = this;

      return $api.post2('kendu/nominas/cotizacion/actualizar', {
        Folio: Folio,
        cerrar: cerrarCotizacion || false,
      }, schema(self, true), {clearCache: 'nominas'}).then(function () {
        self.Cerrada = cerrarCotizacion || false;
      });
    }

    return $api.get('kendu/nominas/cotizacion', {
      Folio: Folio,
    }, {cache: 'nominas'}).then(function (data) {
      return new Cotizacion(schema(data));
    });
  }

  function crearEmpleado(ID_Proyecto, RFC) {
    return $api.post('kendu/nominas/cotizacion/empleados/agregar', {
      ID_Proyecto: ID_Proyecto,
      RFC: RFC,
    });
  }

  // Obtener
  function obtenerIdEmpleado(ID_Proyecto, RFC) {
    return $api.get('kendu/nominas/cotizacion/empleados/empleado/id', {
      ID_Proyecto: ID_Proyecto,
      RFC: RFC,
    });
  }

  // Obtener los empleados disponibles por modalidad de contrato
  function listaEmpleados(ID_Modalidad) {
    return $catalogos.get('proyectosEmpleados', {ID_Modalidad: ID_Modalidad}, {cache: 'nominas'});
  }

  // Obtener lista de percepciones y deducciones disponibles para esta cotización
  function listaConceptos(ID_Proyecto) {
    return $api.get('kendu/nominas/cotizacion/conceptos', {
      ID_Proyecto: ID_Proyecto,
    }, {cache: 'nominas'});
  }

  function schema(data, reverse) {
    return $schema(data, {
      Cerrada: 'boolean',
      Fecha_Inicial: 'date',
      Fecha_Final: 'date',
      Fecha_Pago: 'date',
      Captura_Fecha: 'timestamp',
      Empleados: {
        Percepciones: {
          Importe: 'number',
        },
        Deducciones: {
          Importe: 'number',
        },
      },
    }, reverse);
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/services/NominasCotizacion.js